<template>
    <div id="filter_list_container" :class="[filterName]" :style="{height: 'calc(' + (containerDimensions.cols * colWidth) + ' * var(--vh))', width: 'calc(' + (containerDimensions.rows * rowHeight) + ' * var(--vw))'}"> 
		<div v-if="filterType == 'object'" class="selection_columns_wrapper">
            <div v-for="(availableOption,index) in listOfOptions" :value="availableOption" v-bind:key="index" class="parent_selection_container">
                <div class="parent_selection_display">
                    {{ index }}
                </div>
                <div class="selection_columns parent_selection" :style="{height: 'calc(' + subOptionHeight(availableOption) + ' * var(--vh))'}"> 
                    <div v-for="(subOption, subIndex) in availableOption" :value="subOption" v-bind:key="subIndex" @Click="toggleSubSelection(index, subOption)" class="selection_container sub_selection" :class="[subOptionSelected(index, subOption) ? 'selected' : '']">
                        <span v-if="subOptionSelected(index, subOption)" class="selectedOption">
                            &#10003;
                        </span>
                        {{ subOption }}
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="selection_columns_wrapper" :class="[optionsOverflow ? 'dynamicHeight' : '']">
            <div class="selection_columns">
                <div v-for="(availableOption,index) in listOfOptions" :value="availableOption" v-bind:key="index"  @click="toggleSelection(availableOption)" class="selection_container" :class="[optionSelected(availableOption) ? 'selected' : '']">
                    <span v-if="optionSelected(availableOption)" class="selectedOption">
                        &#10003;
                    </span>
                    {{ availableOption }}
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    export default {
        props: [
            'filterName'
        ],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
            listOfOptions() {
                if(this.filterName == 'models') {
                    return this.$store.getters.getAvailableFilters[this.filterName].available;
                }

                return this.$store.getters.getAvailableFilters[this.filterName].default;
            },
            listOfSelected() {
                return this.$store.getters.getFilterSelectedByName(this.filterName);
            },
            filterType() {
                return this.$store.getters.getAvailableFilters[this.filterName].type;
            },
            isSmall() {
                return ["vehicle_types", "colors"].includes(this.filterName);
            },
            optionsCount() {
                return this.filterName == 'options' ? Object.keys(this.listOfOptions).length : this.listOfOptions.length;
            },
            optionsOverflow() {
                return (this.containerDimensions.cols * this.containerDimensions.rows) < this.optionsCount;
            },
            rowHeight() {
                return this.$store.getters.isMobile ? 48 : 13.5;
            },
            colWidth() {
                return this.$store.getters.isMobile ? 6 : this.filterName == 'models' ? 10 : 6;
            },
            maxRowsVisible() {
                return this.$store.getters.isMobile ? 2 : 6;
            },
            maxColsVisible() {
                return this.$store.getters.isMobile ? 12 : ['makes', 'models'].includes(this.filterName) ? 10 : 7;
            },
            containerDimensions() {
                let cols = 1;
                let rows = 1;
                
                if(this.filterName == 'models' || this.filterName == 'makes') { 
                    cols = this.maxColsVisible;
                    rows = this.maxRowsVisible;
                }
                else {
                    if(this.$store.getters.isMobile) {
                        rows = this.maxRowsVisible;
                        
                        if(this.optionsCount > (this.maxRowsVisible * this.maxColsVisible)) {
                            cols = this.maxColsVisible;
                        }
                        else {
                            while((Math.ceil(this.optionsCount / rows) > cols) && (cols < this.maxColsVisible)) {
                                cols++
                            }
                        }
                    }
                    else {
                        while((this.optionsCount > (cols * rows)) && (rows < this.maxRowsVisible)){
                            if(rows < this.maxRowsVisible) {
                                if(cols == rows) {
                                    rows++;
                                }
                                else {
                                    cols++;
                                }
                            }
                            else {
                                cols++;
                            }
                        }
                    }
                }
                
                document.documentElement.style.setProperty('--dynamicHeight', this.optionHeight());

                return {rows: rows, cols: cols};
            }
        },
        methods: {
            optionSelected(selection) {
                return this.listOfSelected.includes(selection);
            },
            subOptionSelected(selection, subSelection) {
                let selections = Object.keys(this.listOfSelected);

                return (selections.includes(selection) && this.listOfSelected[selection].includes(subSelection));
            },
            toggleSelection(availableOption) {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('toggle', {'event_category': 'filter_selection','event_label': eventLabel});
                this.$store.commit('toggleListFilterSelection', {name: this.filterName, selection: availableOption});
                this.$store.commit('notifySearchQueryChanges', true);
            },
            toggleSubSelection(availableOption, subOption) {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('toggle', {'event_category': 'filter_selection','event_label': eventLabel});
                this.$store.commit('toggleObjectFilterSelection', {name: this.filterName, selection: availableOption, subSelection: subOption});
                this.$store.commit('notifySearchQueryChanges', true);
            },
            optionHeight() {
                let height = 74;

                if(this.$store.getters.isMobile) {
                    if(this.optionsCount > (this.maxRowsVisible * this.maxColsVisible)) {
                        height = Math.ceil(this.optionsCount / this.maxRowsVisible) * this.colWidth;
                    }
                }
                else {
                    if(this.optionsCount > (this.maxRowsVisible * this.maxColsVisible)) {
                        height = Math.ceil(this.optionsCount / this.maxRowsVisible) * this.colWidth;
                    }
                }

                return height;
            },
            subOptionHeight(availableOption) {
                let numberOfRows = (Math.ceil(availableOption.length / this.maxRowsVisible));

                numberOfRows = numberOfRows + Math.floor((numberOfRows - 1) / 3);
                
                return numberOfRows * this.colWidth;
            }
        }
    }
</script>

<style>
    #filter_list_container {
        max-height: calc(42 * var(--vh));
        max-width: calc(81 * var(--vw));
        overflow-y: scroll;
    }

    .inmobile #filter_list_container  {
        max-height: calc(74 * var(--vh));
        min-width: calc(96 * var(--vw));
        width: calc(96 * var(--vw));
        max-width: calc(96 * var(--vw));
        overflow-y: scroll;
    }

    #filter_list_container.models {
        overflow-y: scroll;
    }

    .makes #filter_list_container,
    .models #filter_list_container {
        max-height: calc(60 * var(--vh))
    }

    ::-webkit-scrollbar {
        width: 0px;  /* remove scrollbar space */
        background: transparent;  /* optional: just make scrollbar invisible */
    }

    .selection_columns_wrapper {
        height: inherit;
        max-height: inherit;
        width: inherit;
        max-width: inherit;
    }

    .inmobile .selection_columns_wrapper {
        max-width:  calc(96 * var(--vw));
    }

    .dynamicHeight {
        height: calc(var(--dynamicHeight) * var(--vh));
        max-height: calc(var(--dynamicHeight) * var(--vh));
    }

    .selection_columns {
        /*width: 100%;*/
        max-width: inherit;
        height: inherit;
        max-height: inherit;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }

    .parent_selection {
        /*padding: 0 calc(2 * var(--vw));*/
        width: calc(81 * var(--vw));
        max-width: calc(81 * var(--vw));
    }

    .parent_selection_container {
        /*width: 100%;*/
        max-width: inherit;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: calc(3 * var(--vh)) 0;
    }

    .parent_selection_display {
        font-weight: bolder;
        width: 100%;
        font-size: 1.75em;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
    }

    .selection_container {
        width: calc(13.5 * var(--vw));
        min-height: calc(6 * var(--vh));
        max-height: calc(12 * var(--vh));
        display: flex; 
        justify-content: center;
        align-items: center;
        text-align: center;
        cursor: pointer;
    }

    .sub_selection {
        height: calc(8 * var(--vh));
    }

    .selection_container.selected {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }

    .selection_container:hover {
        color: var(--mccluskeyGold); /* #AF873F;*/
    }

    .inmobile .selection_container {
        width: calc(44 * var(--vw));
        height: calc(6 * var(--vh));
    }

    .selectedOption {
        color: var(--mccluskeyBlue);/*#3378B1;*/
        font-weight: bolder;
    }
</style>
